import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestAddDto, RequestApproveDto, RequestCancelRequestDto, RequestDeleteDraftDto, RequestGetDetailDateDto, RequestGetRequestDetailDto, RequestRejectDto, RequestReviseDto, RequestSaveDto, ResponeGetDetailDateNewDto, ResponseAddDto, ResponseApproveDto, ResponseCancelRequestDto, ResponseGetDetailDateDto, ResponseGetRequestDetailDto, ResponseGetTotalDaysDto, ResponseRejectDto, ResponseReviseDto, ResponseSaveDto } from "../dto/sf-leave-cancel-request.dto";

@Injectable()
export class SfLeaveCancelRequestApi {
  private service: string = '';
  private model: string = 'sfLeaveCancelRequest';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getDetailDate(payload: RequestGetDetailDateDto): Observable<ResponseGetDetailDateDto> {
    const method: string = 'POST';
    const func: string = 'getDetailDate';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetDetailDateDto>(method, url, params, urlParams, body);
  }

  public getDetailDateNew(payload: RequestGetDetailDateDto) {
    const method = 'POST';
    const func = 'getDetailDateNew';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponeGetDetailDateNewDto[]>>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: RequestSaveDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestDeleteDraftDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public cancelRequest(payload: RequestCancelRequestDto): Observable<ResponseCancelRequestDto> {
    const method: string = 'POST';
    const func: string = 'cancelRequest';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelRequestDto>(method, url, params, urlParams, body);
  }

  public revise(payload: RequestReviseDto): Observable<ResponseReviseDto> {
    const method: string = 'POST';
    const func: string = 'revise';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReviseDto>(method, url, params, urlParams, body);
  }

  public reject(payload: RequestRejectDto): Observable<ResponseRejectDto> {
    const method: string = 'POST';
    const func: string = 'reject';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseRejectDto>(method, url, params, urlParams, body);
  }

  public getRequestDetail(payload: RequestGetRequestDetailDto): Observable<ResponseGetRequestDetailDto> {
    const method: string = 'POST';
    const func: string = 'getRequestDetail';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetRequestDetailDto>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestApproveDto): Observable<ResponseApproveDto> {
    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, params, urlParams, body);
  }

  getTotalDays(data): Observable<ResponseGetTotalDaysDto> {
    const method: string = 'POST';
    const func: string = 'getTotalDays';
    const params: any = {
      leaveReqNo: data
    };
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTotalDaysDto>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-leave-cancel-request.api.ts